// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../font/Roboto-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../font/Roboto-Light.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../../font/CenturyGothic.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "Roboto-Regular";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
}
@font-face {
  font-family: "Roboto-Light";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("truetype");
}
@font-face {
  font-family: "Century Gothic";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("truetype");
}
.App {
  position: relative;
  overflow-x: hidden;
}
.App .modal_popup {
  position: relative;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #999;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 6px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.5);
  outline: 0;
}
@media screen and (min-width: 681px) {
  .App .modal_popup {
    width: 600px;
    margin: 30px auto;
    padding: 15px;
  }
}
@media screen and (max-width: 680px) {
  .App .modal_popup {
    width: 350px;
    margin: 30px auto;
    padding: 15px;
  }
}
@media screen and (max-width: 380px) {
  .App .modal_popup {
    width: 300px;
  }
}
@media screen and (min-width: 681px) {
  .App .modal_popup .popup-btn-close .pop-up-adw-img {
    width: 600px;
  }
}
@media screen and (max-width: 680px) {
  .App .modal_popup .popup-btn-close .pop-up-adw-img {
    width: 350px;
  }
}
@media screen and (max-width: 380px) {
  .App .modal_popup .popup-btn-close .pop-up-adw-img {
    width: 300px;
  }
}
.App .modal_popup .close {
  -webkit-appearance: none;
  padding: 0;
  background: 0 0;
  border: none;
  float: right;
  font-weight: 700;
  line-height: 1;
  color: rgb(0, 0, 0);
  text-shadow: 0 1px 0 #fff;
  opacity: 0.2;
  cursor: pointer;
}
@media screen and (min-width: 681px) {
  .App .modal_popup .close {
    font-size: 21px;
  }
}
@media screen and (max-width: 680px) {
  .App .modal_popup .close {
    font-size: 40px;
  }
}`, "",{"version":3,"sources":["webpack://./styles/fonts.scss","webpack://./src/components/App/App.scss"],"names":[],"mappings":"AAAA;EACI,6BAAA;EACA,+DAAA;ACCJ;ADEA;EACI,2BAAA;EACA,+DAAA;ACAJ;ADGA;EACI,6BAAA;EACA,+DAAA;ACDJ;AATA;EACE,kBAAA;EACA,kBAAA;AAWF;AATE;EACE,kBAAA;EACA,sBAAA;EAEA,4BAAA;EACA,sBAAA;EACA,oCAAA;EACA,kBAAA;EACA,yCAAA;EACA,UAAA;AAWJ;AATI;EAXF;IAYI,YAAA;IACA,iBAAA;IACA,aAAA;EAYJ;AACF;AAVI;EAjBF;IAkBI,YAAA;IACA,iBAAA;IACA,aAAA;EAaJ;AACF;AAXI;EAvBF;IAwBI,YAAA;EAcJ;AACF;AAVQ;EADF;IAEI,YAAA;EAaR;AACF;AAXQ;EALF;IAMI,YAAA;EAcR;AACF;AAbQ;EARF;IASI,YAAA;EAgBR;AACF;AAZI;EACE,wBAAA;EACA,UAAA;EACA,eAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,YAAA;EACA,eAAA;AAcN;AAZM;EAbF;IAcI,eAAA;EAeN;AACF;AAbM;EAjBF;IAkBI,eAAA;EAgBN;AACF","sourcesContent":["@font-face {\n    font-family: \"Roboto-Regular\"; \n    src: url(\"../font/Roboto-Regular.ttf\") format(\"truetype\");  \n}\n\n@font-face {\n    font-family: \"Roboto-Light\"; \n    src: url(\"../font/Roboto-Light.ttf\") format(\"truetype\");  \n}\n\n@font-face {\n    font-family: \"Century Gothic\"; \n    src: url(\"../font/CenturyGothic.ttf\") format(\"truetype\");  \n}\n\n","@import '../../../styles/fonts.scss';\n\n.App {\n  position: relative;\n  overflow-x: hidden;\n\n  .modal_popup {\n    position: relative;\n    background-color: #fff;\n    -webkit-background-clip: padding-box;\n    background-clip: padding-box;\n    border: 1px solid #999;\n    border: 1px solid rgba(0, 0, 0, .2);\n    border-radius: 6px;\n    box-shadow: 0 5px 15px rgba(0, 0, 0, .5);\n    outline: 0;\n\n    @media screen and (min-width: 681px) {\n      width: 600px;\n      margin: 30px auto;\n      padding: 15px;\n    }\n\n    @media screen and (max-width: 680px) {\n      width: 350px;\n      margin: 30px auto;\n      padding: 15px;\n    }\n    \n    @media screen and (max-width: 380px) {\n      width: 300px;\n    }\n\n    .popup-btn-close {\n      .pop-up-adw-img {\n        @media screen and (min-width: 681px) {\n          width: 600px;\n        }\n    \n        @media screen and (max-width: 680px) {\n          width: 350px;\n        }\n        @media screen and (max-width: 380px) {\n          width: 300px;\n        }\n    }\n    }\n\n    .close {\n      -webkit-appearance: none;\n      padding: 0;\n      background: 0 0;\n      border: none;\n      float: right;\n      font-weight: 700;\n      line-height: 1;\n      color: rgb(0, 0, 0);\n      text-shadow: 0 1px 0 #fff;\n      opacity: .2;\n      cursor: pointer;\n\n      @media screen and (min-width: 681px) {\n        font-size: 21px;\n      }\n  \n      @media screen and (max-width: 680px) {\n        font-size: 40px;\n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
